"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.color2Class = exports.formatLength = void 0;
var format_length_1 = require("./format-length");
Object.defineProperty(exports, "formatLength", { enumerable: true, get: function () { return format_length_1.formatLength; } });
var color_to_class_1 = require("./color-to-class");
Object.defineProperty(exports, "color2Class", { enumerable: true, get: function () { return color_to_class_1.color2Class; } });
